import { render, staticRenderFns } from "./inputNumber.vue?vue&type=template&id=43ff2fda&"
import script from "./inputNumber.vue?vue&type=script&lang=ts&setup=true&"
export * from "./inputNumber.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports